class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold, 10) || 0;
    this.awayMsg = this.dataset.awayMessage || '';
    this.reachedMsg = this.dataset.reachedMessage || '';
    this.startMsg = this.dataset.startMessage || '';
    this.textEl = this.querySelector('[data-ship-text]');
    this.fillEl = this.querySelector('[data-ship-fill]');
    this.trackEl = this.querySelector('[role="progressbar"]');
    this.currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    this.locale = document.documentElement.lang || 'en-US';

    this.onCartUpdate = this.onCartUpdate.bind(this);
    document.addEventListener('cart:update', this.onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this.onCartUpdate);
  }

  onCartUpdate(event) {
    const cart = event && event.detail && event.detail.resource;
    if (!cart) return;
    const total = typeof cart.total_price === 'number' ? cart.total_price : 0;
    const itemCount = typeof cart.item_count === 'number' ? cart.item_count : 0;
    this.update(total, itemCount);
  }

  formatMoney(cents) {
    const amount = cents / 100;
    const hasDecimals = Math.abs(amount - Math.round(amount)) > 0.0001;
    try {
      return new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: hasDecimals ? 2 : 0,
        maximumFractionDigits: hasDecimals ? 2 : 0,
      }).format(amount);
    } catch (e) {
      return `$${amount.toFixed(hasDecimals ? 2 : 0)}`;
    }
  }

  update(totalCents, itemCount) {
    const percent =
      this.threshold > 0 ? Math.min(100, (totalCents / this.threshold) * 100) : 0;
    const reached = this.threshold > 0 && totalCents >= this.threshold;

    if (this.fillEl) this.fillEl.style.width = `${percent}%`;
    if (this.trackEl)
      this.trackEl.setAttribute('aria-valuenow', String(Math.round(percent)));

    let text;
    if (itemCount === 0) {
      text = this.startMsg;
    } else if (reached) {
      text = this.reachedMsg;
    } else {
      const remaining = Math.max(0, this.threshold - totalCents);
      text = this.awayMsg.replace('{amount}', this.formatMoney(remaining));
    }
    if (this.textEl) this.textEl.textContent = text;

    this.classList.toggle('free-shipping-bar--reached', reached);
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}
